import { render, staticRenderFns } from "./AppFormWidgetItem.vue?vue&type=template&id=5a86e7ef&scoped=true&"
import script from "./AppFormWidgetItem.vue?vue&type=script&lang=js&"
export * from "./AppFormWidgetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a86e7ef",
  null
  
)

export default component.exports